import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TripLandingPageWhatOurTravellersSay from './TripLandingPageWhatOurTravellersSay'
import TripLandingTheresMoreAnimatedBackground from 'tripPlanner/Tripkit/TripLandingTheresMoreAnimatedBackground'
import { FormattedMessage } from 'react-intl'

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const StyledSheet = styled(Sheet)`
  display: grid;
  grid-template: "content" 1fr / 1fr;
  position: relative;
  min-height: 100%;
  width: 100%;
`

const StyledTripLandingAnimatedBackground = styled(TripLandingTheresMoreAnimatedBackground)`
  grid-area: content;
  position: absolute;
  top: ${rem(-48)};
  inset-inline: 0;
  bottom: 0;
  z-index: 0;
`

const ContentContainer = styled.div`
  grid-area: content;
  position: relative;
  z-index: 1;
  min-height: 100%;
  width: 100%;
`
const StyledSheetTransparent = styled(Sheet)`
  background: rgba(255,255,255, 0.16);
`

function TripLandingPageAndTheresMore() {
  return (
    <StyledSheet paletteType="inverse" background="normal-background">
      <StyledTripLandingAnimatedBackground />
      <ContentContainer>
        <Sheet padding="48 0 48 0">
          <LayoutContainer>
            <Group direction="vertical" verticalAlign="center" horizontalAlign="center" gap={32}>
              <HeadingTextBlock variant="heading2">
                <FormattedMessage
                  id="6I1ZfZs9xbccgDfBlc5N"
                  defaultMessage="And there’s more..."
                  description="Section heading for additional features section in the trip planner"
                />
              </HeadingTextBlock>
              <GridContainer>
                <StyledSheetTransparent
                  paletteType="inverse"
                  padding="24 20"
                  borderRadius="L"
                >
                  <Group direction="vertical" horizontalAlign="center" gap={24}>
                    <ResponsiveImage id="s98iv3aizbgamsisq8i" />
                    <VerticalSpacer gap={4}>
                      <Group direction="vertical" horizontalAlign="center" gap={4}>
                        <Heading variant="heading5" align="center">
                          <FormattedMessage
                            id="B7Was6T36pDvOoPdqTif"
                            defaultMessage="Store all your travel docs"
                            description="Section heading for store travel docs feature in the trip planner"
                          />
                        </Heading>
                        <BodyText variant="large" align="center">
                          <FormattedMessage
                            id="p19ib9uAPS0Dk_kdeg-W"
                            defaultMessage="TripPlanner keeps all your travel essentials in one spot like tickets, bookings, confirmation numbers, and notes."
                            description="Description for store travel docs feature in the trip planner"
                          />
                        </BodyText>
                      </Group>
                    </VerticalSpacer>
                  </Group>

                </StyledSheetTransparent>
                <StyledSheetTransparent
                  paletteType="inverse"
                  padding="24 20"
                  borderRadius="L"
                >
                  <Group direction="vertical" horizontalAlign="center" gap={24}>
                    <ResponsiveImage id="3fbe5uaqz82gk7ckef1g" />
                    <VerticalSpacer gap={4}>
                      <Group direction="vertical" horizontalAlign="center" gap={4}>
                        <Heading variant="heading5" align="center">
                          <FormattedMessage
                            id="oZVhXDGQJqdAlRXZzN62"
                            defaultMessage="Smarter maps, smoother days"
                            description="Heading for smarter maps feature on the map or location view"
                          />
                        </Heading>
                        <BodyText variant="large" align="center">
                          <FormattedMessage
                            id="r75J0rwvrNtyDAOo-ekT"
                            defaultMessage="Visualise your trip with a live, interactive map with estimated times between stops."
                            description="Description for smarter maps feature in the trip planner feature"
                          />
                        </BodyText>
                      </Group>
                    </VerticalSpacer>
                  </Group>
                </StyledSheetTransparent>
                <StyledSheetTransparent
                  paletteType="inverse"
                  padding="24 20"
                  borderRadius="L"
                >
                  <Group direction="vertical" horizontalAlign="center" gap={24}>
                    <ResponsiveImage id="6gw6zqyppb6uhblvyonf" />
                    <VerticalSpacer gap={4}>
                      <Group direction="vertical" horizontalAlign="center" gap={4}>
                        <Heading variant="heading5" align="center">
                          <FormattedMessage
                            id="HcgZQTqjUOaOudN4wnsL"
                            defaultMessage="Discover what’s nearby"
                            description="Section heading for discover nearby feature in the trip planner"
                          />
                        </Heading>
                        <BodyText variant="large" align="center">
                          <FormattedMessage
                            id="jszOnfD_3IRNl0iDvn20"
                            defaultMessage="We’ll show you what’s worth seeing, tasting, or trying near each stop. You can make the most of every moment without the extra planning."
                            description="Description for discover nearby feature in the trip planner"
                          />
                        </BodyText>
                      </Group>
                    </VerticalSpacer>
                  </Group>
                </StyledSheetTransparent>
              </GridContainer>
            </Group>
          </LayoutContainer>
        </Sheet>
        <TripLandingPageWhatOurTravellersSay />
      </ContentContainer>
    </StyledSheet>

  )
}

export default TripLandingPageAndTheresMore
